<template>
    <span>
      <!-- AUTOSUGGEST -->
      <div class=" autosuggtest relative" v-if="type == 'autosuggest'">
        <input :disabled="disabled == true" :class="[css_class, validInput ? 'greenborder' : '']" v-model="input" :size="size" :placeholder="placeholder" v-on:keyup="showDetails()" @focus="suggestions_appear = true" @blur=" hover_options ? true: suggestions_appear = false"/>
        <div class="selection-details" v-if="details" v-show="suggestions_appear">
            <ul id="v-for-object" @mouseover="hover_options = true" @mouseleave="hover_options = false">
              <li v-for="item of suggestions" v-bind:key="item.key" v-on:click="selectDetails(item.key,item.val)" >
                <span v-html="item.val"></span>
              </li>
            </ul>
        </div>
        <div class="crossout absolute" v-on:click="resetInput()" v-if="selected != ''">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0001 0.666626C6.66675 0.666626 0.666748 6.66663 0.666748 14C0.666748 21.3333 6.66675 27.3333 14.0001 27.3333C21.3334 27.3333 27.3334 21.3333 27.3334 14C27.3334 6.66663 21.3334 0.666626 14.0001 0.666626ZM11.3334 20.6666L4.66675 14L6.54675 12.12L11.3334 16.8933L21.4534 6.77329L23.3334 8.66663L11.3334 20.6666Z" fill="#0176CD"/>
          </svg>
        </div>
        <div class="input-search-icon absolute" v-else>
          <svg class="input-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66667 0C10.9652 0 13.1696 0.913092 14.7949 2.53841C16.4202 4.16372 17.3333 6.36812 17.3333 8.66667C17.3333 10.8133 16.5467 12.7867 15.2533 14.3067L15.6133 14.6667H16.6667L23.3333 21.3333L21.3333 23.3333L14.6667 16.6667V15.6133L14.3067 15.2533C12.7867 16.5467 10.8133 17.3333 8.66667 17.3333C6.36812 17.3333 4.16372 16.4202 2.53841 14.7949C0.913092 13.1696 0 10.9652 0 8.66667C0 6.36812 0.913092 4.16372 2.53841 2.53841C4.16372 0.913092 6.36812 0 8.66667 0ZM8.66667 2.66667C5.33333 2.66667 2.66667 5.33333 2.66667 8.66667C2.66667 12 5.33333 14.6667 8.66667 14.6667C12 14.6667 14.6667 12 14.6667 8.66667C14.6667 5.33333 12 2.66667 8.66667 2.66667Z" fill="#0176CD"/>
          </svg>          
        </div>
      </div>

      <!-- SELECTION -->
      <div class=" selection relative" v-if="type == 'selection'">
          <input :disabled="disabled == true" :class="[css_class, validInput ? 'greenborder' : '']" v-model="input" :size="size" :placeholder="placeholder" v-on:keyup="showDetails()" @focus="suggestions_appear = true" @click="suggestions_appear = true, details = true" @blur=" hover_options ? true: suggestions_appear = false"/>
          <div class="selection-details" v-if="details" v-show="suggestions_appear">
            <ul id="v-for-object" @mouseover="hover_options = true" @mouseleave="hover_options = false">
              <li v-for="item of data_source" v-bind:key="item.key" v-on:click="selectDetails(item.key,item.val)" >
                <span v-html="item.val"></span>
              </li>
            </ul>
        </div>
        <div class="crossout white absolute" v-on:click="resetInput()" v-if="input != ''">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0001 0.666626C6.66675 0.666626 0.666748 6.66663 0.666748 14C0.666748 21.3333 6.66675 27.3333 14.0001 27.3333C21.3334 27.3333 27.3334 21.3333 27.3334 14C27.3334 6.66663 21.3334 0.666626 14.0001 0.666626ZM11.3334 20.6666L4.66675 14L6.54675 12.12L11.3334 16.8933L21.4534 6.77329L23.3334 8.66663L11.3334 20.6666Z" fill="#0176CD"/>
          </svg>
        </div>
        <div class="input-search-icon white absolute" v-else>
          <svg class="input-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66667 0C10.9652 0 13.1696 0.913092 14.7949 2.53841C16.4202 4.16372 17.3333 6.36812 17.3333 8.66667C17.3333 10.8133 16.5467 12.7867 15.2533 14.3067L15.6133 14.6667H16.6667L23.3333 21.3333L21.3333 23.3333L14.6667 16.6667V15.6133L14.3067 15.2533C12.7867 16.5467 10.8133 17.3333 8.66667 17.3333C6.36812 17.3333 4.16372 16.4202 2.53841 14.7949C0.913092 13.1696 0 10.9652 0 8.66667C0 6.36812 0.913092 4.16372 2.53841 2.53841C4.16372 0.913092 6.36812 0 8.66667 0ZM8.66667 2.66667C5.33333 2.66667 2.66667 5.33333 2.66667 8.66667C2.66667 12 5.33333 14.6667 8.66667 14.6667C12 14.6667 14.6667 12 14.6667 8.66667C14.6667 5.33333 12 2.66667 8.66667 2.66667Z" fill="#0176CD"/>
          </svg>          
        </div>
      </div>



      <div class=" selection relative" v-if="type == 'type_selection'">
          <input :disabled="disabled == true" :class="[css_class, validInput ? 'greenborder' : '']" v-model="input" :size="size" :placeholder="placeholder" v-on:keyup="showDetails()" @focus="suggestions_appear = true" @blur=" hover_options ? true: suggestions_appear = false"/>
          <div class="selection-details" v-if="details" v-show="suggestions_appear">
            <ul id="v-for-object" @mouseover="hover_options = true" @mouseleave="hover_options = false">
              <li v-for="item of data_source" v-bind:key="item.key" v-on:click="selectDetails(item.key,item.val)" >
                <span v-html="item.val"></span>
              </li>
            </ul>
        </div>
        <div class="crossout white absolute" v-on:click="resetInput()" v-if="input != ''">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0001 0.666626C6.66675 0.666626 0.666748 6.66663 0.666748 14C0.666748 21.3333 6.66675 27.3333 14.0001 27.3333C21.3334 27.3333 27.3334 21.3333 27.3334 14C27.3334 6.66663 21.3334 0.666626 14.0001 0.666626ZM11.3334 20.6666L4.66675 14L6.54675 12.12L11.3334 16.8933L21.4534 6.77329L23.3334 8.66663L11.3334 20.6666Z" fill="#0176CD"/>
          </svg>
        </div>
        <div class="input-search-icon white absolute" v-else>
          <svg class="input-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66667 0C10.9652 0 13.1696 0.913092 14.7949 2.53841C16.4202 4.16372 17.3333 6.36812 17.3333 8.66667C17.3333 10.8133 16.5467 12.7867 15.2533 14.3067L15.6133 14.6667H16.6667L23.3333 21.3333L21.3333 23.3333L14.6667 16.6667V15.6133L14.3067 15.2533C12.7867 16.5467 10.8133 17.3333 8.66667 17.3333C6.36812 17.3333 4.16372 16.4202 2.53841 14.7949C0.913092 13.1696 0 10.9652 0 8.66667C0 6.36812 0.913092 4.16372 2.53841 2.53841C4.16372 0.913092 6.36812 0 8.66667 0ZM8.66667 2.66667C5.33333 2.66667 2.66667 5.33333 2.66667 8.66667C2.66667 12 5.33333 14.6667 8.66667 14.6667C12 14.6667 14.6667 12 14.6667 8.66667C14.6667 5.33333 12 2.66667 8.66667 2.66667Z" fill="#0176CD"/>
          </svg>          
        </div>
      </div>

      <!-- PRICE -->
      <div class=" selection relative" v-if="type == 'price'">
          <input :disabled="disabled == true" v-currency="{currency: {prefix:'EUR ',suffix:''}, locale: 'de', distractionFree: false, precision: 0, valueRange: { min: 1, max: 99999999},}" :class="[css_class, validInput ? 'greenborder' : '']" v-model="input" :size="size" :placeholder="placeholder" v-on:keyup="showDetails()" @focus="suggestions_appear = true" @blur=" hover_options ? true: suggestions_appear = false"/>
          <div class="selection-details" v-if="details">
            <ul id="v-for-object">
              <li class="test" v-for="item of data_source" v-bind:key="item.key" v-on:click="selectDetails(item.key,item.val)" >
                <span v-html="item.val"></span>
              </li>
            </ul>
        </div>
        <div class="crossout white absolute" v-on:click="resetInput()" v-if="input != ''">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0001 0.666626C6.66675 0.666626 0.666748 6.66663 0.666748 14C0.666748 21.3333 6.66675 27.3333 14.0001 27.3333C21.3334 27.3333 27.3334 21.3333 27.3334 14C27.3334 6.66663 21.3334 0.666626 14.0001 0.666626ZM11.3334 20.6666L4.66675 14L6.54675 12.12L11.3334 16.8933L21.4534 6.77329L23.3334 8.66663L11.3334 20.6666Z" fill="#0176CD"/>
          </svg>
        </div>
        <div class="input-search-icon white absolute" v-else>
          <svg class="input-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.66667 0C10.9652 0 13.1696 0.913092 14.7949 2.53841C16.4202 4.16372 17.3333 6.36812 17.3333 8.66667C17.3333 10.8133 16.5467 12.7867 15.2533 14.3067L15.6133 14.6667H16.6667L23.3333 21.3333L21.3333 23.3333L14.6667 16.6667V15.6133L14.3067 15.2533C12.7867 16.5467 10.8133 17.3333 8.66667 17.3333C6.36812 17.3333 4.16372 16.4202 2.53841 14.7949C0.913092 13.1696 0 10.9652 0 8.66667C0 6.36812 0.913092 4.16372 2.53841 2.53841C4.16372 0.913092 6.36812 0 8.66667 0ZM8.66667 2.66667C5.33333 2.66667 2.66667 5.33333 2.66667 8.66667C2.66667 12 5.33333 14.6667 8.66667 14.6667C12 14.6667 14.6667 12 14.6667 8.66667C14.6667 5.33333 12 2.66667 8.66667 2.66667Z" fill="#0176CD"/>
          </svg>          
        </div>
      </div>

      <!-- SELECTION -->
      <div class="selection relative" v-if="type == 'gender_selection'">
          <input readonly :disabled="disabled == true" :class="[css_class, validInput ? 'greenborder' : '']" v-model="input" :size="size" :placeholder="placeholder" @focus="suggestions_appear = true" @click="suggestions_appear = true, details = true" @blur=" hover_options ? true: suggestions_appear = false"/>
          <div class="selection-details" v-if="details" v-show="suggestions_appear">
            <ul id="v-for-object" @mouseover="hover_options = true" @mouseleave="hover_options = false">
              <li v-for="item of data_source" v-bind:key="item.key" v-on:click="selectDetails(item.key,item.val)" >
                <span v-html="item.val"></span>
              </li>
            </ul>
        </div>
        <div class="dropdown-triangle white absolute" >
          <!-- Triangle pointing down when closed, up when open -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!suggestions_appear">
            <path d="M7 10L12 15L17 10H7Z" fill="#fff"/>
          </svg>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
            <path d="M7 14L12 9L17 14H7Z" fill="#fff"/>
          </svg>
        </div>

      </div>

    </span>
</template>

<script>

import axios from 'axios';

import { EventBus } from "@/event-bus.js";
//import { CurrencyInput } from 'vue-currency-input'

export default {
    name: 'InputSuggestion',
    props: {
      type: String,
      uri: String,
      uri_suggest_key: String,
      uri_suggest_key_2: String,
      event_name: String,
      data_source: Array,
      auto_open: Boolean,
      css_class: String,
      placeholder: String,
      validInput: Boolean,
      disabled: Boolean,
      branche: String
    },
    data() {
      return {
        details: false,
        suggestions: [],
        suggestions_appear: false,
        hover_options: false,
        input: '',
        input_val: '',
        id: -1,
        selected: false,
        errors: [],
        size: 0,
      }
    },
    created() {
      if(this.auto_open) {
          if(this.type == 'selection') {
            this.showDetails();
          }
          if(this.type == 'numberselection'){
            this.showdetails();
          }
          
      }
      if(this.type == 'autosuggest') {
        //console.log('InputSuggestion: created() Type: Autosuggest for Element-Event: ' + this.event_name  );
        if(this.data_source != undefined) {
          if(this.suggestions.length > 0) {
              this.input = this.data_source[0];
              this.selected = true;
              this.details=false;
          }
        }
      }

      EventBus.$on("evaluateNewMachine", () => {
        this.details= false;
        this.suggestions= [];
        this.suggestions_appear= false;
        this.hover_options= false;
        this.input= '';
        this.input_val= '';
        this.id= -1;
        this.selected= false;
        this.errors= [];
        this.size= 0;
      });
     },
    watch: {
      input: function(newValue, oldValue) {
        if(newValue != oldValue) {
          EventBus.$emit(""+this.event_name, {
            'id': 0,
            'input': newValue
          });
        }
      },
      data_source: function () {
        if(this.type == "prefilled-text") {
            if(this.data_source.length == 1) {
              this.input = this.data_source[0];
              this.size = this.input.length;
              this.selected = true;
              this.details=false;
            }
        }
      }
    },
    methods: {
      updateValue(payload){
        console.log('update value')
        this.input = payload;
      },
      resetInput(){
        this.input = ''
      },
      showDetails: function() {
         if(this.type == 'autosuggest' ) {
          this.details = true;
          var kvMap = {};
          var brancheMap = {};
          kvMap[ this.uri_suggest_key ] = this.input;
          brancheMap[ this.uri_suggest_key_2 ] = this.branche;

          if(this.input.length > 0) {

            let uri_prefix = 'https://enquiry.leaseback.de';
            if(window.location.host == "onboarding.leaseback.de") {
              uri_prefix = 'https://enquiry.leaseback.de';
            }

            //console.log(this.uri_suggest_key);

            // if machinecategory -> use special axios call with 2 parameters
            if(this.uri_suggest_key == "machinecategory"){
              axios.post(uri_prefix + this.uri,{machinecategory: this.input, branche: this.branche}).then(response => {
                this.suggestions = response.data
                this.suggestions_appear = true
              
                }).catch(e => {
                  console.log(e);
                  this.errors.push(e)
                });
            }else{
               axios.post(uri_prefix + this.uri,kvMap).then(response => {
                this.suggestions = response.data
                this.suggestions_appear = true
              
                }).catch(e => {
                  console.log(e);
                  this.errors.push(e)
                });              
            }

          }else{
            this.suggestions_appear = false;
          }
        } 
        if(this.type == 'selection' || this.type == 'numberselection') {
          //console.log('InputSuggestion.vue showing-details for selection');
          if(this.event_name == "machinetype_selected"){
            this.details = false;
            this.suggestions_appear = false;
          }else{
            this.details = true;
            this.suggestions_appear = true;
          }
        }     
      },
      selectDetails: function(key,val) {
        //console.log('InputSuggestion.vue: selectDetails.clicked:' + val);
        this.selected = true;
        this.input = key;
        this.input_val = val;
        this.size = this.input.length;
        this.id = key;
        this.selected = true;
        this.details = false;
        this.suggestions_appear = false;
        this.hover_options = false;

        let this2 = this;
        //console.log('InputSuggestion.vue: Emitting Event: ' + this.event_name);
        EventBus.$emit(""+this.event_name, {
          'id': this2.id,
          'input': this2.input,
        });
      },
    }
}
</script>

<style >
*,*:focus,*:hover{
    outline:none;
}

.selection{
  cursor: pointer;
}

.selection-details {
  background-color: #0176CD;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  top: 100%;
  z-index: 99;
  color: #fff;

}
.selection-details ul{
  overflow: auto;
  max-height: 300px;
  padding: 0;
  margin: 1rem 0;
  max-width: 100%;
}
.selection-details ul {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.selection-details ul::-webkit-scrollbar{
   width: 15px;
   height: 40px;
}

.selection-details ul::-webkit-scrollbar-thumb{
   background-color: #DBDBDB;
   border: 4px solid transparent;
   border-radius: 11px;
   background-clip: content-box;
}

.selection-details ul::-webkit-scrollbar * {
   background: transparent;
}

.selection-details ul::-webkit-scrollbar-thumb:vertical {
   height: 90px;
}
.selection-details li:hover {
  background-color: #0056b1;
}

.selection-details li {
  margin: .5rem 0;
}

.selection-details li span {
  margin: 0 1rem;
}

.crossout{
  top: 70%;
  transform: translate(-32%, -78%);
  right: 0;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  background-color: #fff;
}

.dropdown-triangle{
  top: 72.5%;
  transform: translate(-50%, -100%);
  right: 0;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  background-color: #0176CD;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dropdown-triangle svg{
  margin-right: 0;
}

.input-search-icon{
  top: 72.5%;
  transform: translate(-32%, -78%);
  right: 0;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  background-color: #fff;
}

::placeholder {
  font-style: italic;
  width: 100%;
  color: #a3a3a3 !;
}

.x-cross{
  width: .8rem;
  height: .8rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);

}
.x-cross:hover{
  cursor: pointer;
}

.greenborder{
  border: 2px solid #0176CD;
}

.disabledInput{
  opacity: 0.5;
}



/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
input{
  font-weight: 200;
  letter-spacing: 1.1px;
}

@media(max-width: 425px){
  ::placeholder {
    width: 75%;
  }
}
</style>